var React = require('react');

function QuoteGreen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.9 14.5C3.3 6.1 9 0 14.6 0c.5 0 .9 0 1.3.1.2 0 .5.2.6.4s.2.5.1.7l-1.2 4.1c-.1.4-.5.7-.9.7h-.1c-2.1 0-5.9 3.1-7.8 10.1l-.2.9c2.2-1.1 4.8-1.3 7.1-.7a10 10 0 0 1 6.9 12.4 10 10 0 0 1-9.6 7.3c-.9 0-1.8-.1-2.7-.4-3.5-1-6.1-3.9-7.4-8.2a24 24 0 0 1 .1-12.9zM37.7 0c.4 0 .9 0 1.3.1.2 0 .5.2.6.4s.2.5.1.7l-1.2 4.1c-.1.4-.5.7-.9.7h-.1c-2.1 0-5.9 3.1-7.8 10.1l-.2.9c2.2-1.1 4.8-1.3 7.1-.7a10 10 0 0 1 6.9 12.4A10 10 0 0 1 34 36c-.9 0-1.8-.1-2.7-.4-3.5-1-6.1-3.9-7.4-8.2a24 24 0 0 1 .1-12.9C26.4 6.1 32.1 0 37.7 0z"}));
}

QuoteGreen.defaultProps = {"width":"44","height":"36","fill":"#47D983"};

module.exports = QuoteGreen;

QuoteGreen.default = QuoteGreen;
